<template>
  <v-row class="my-0">
    <v-col class="my-0 py-0">
      <v-row
        class="my-0"
        align="center"
      >
        <v-col cols="auto">
          <v-img
            :src="require('@/assets/images/ui/bottom-nav/network.svg')"
            max-width="29"
          />
        </v-col>
        <v-col>
          <div class="title">
            <router-link
              v-if="linkToConnections"
              to="/connections"
              @click.native="handleConnectionsLinkClick"
            >
              {{ title }}
            </router-link>
            <span v-else>{{ title }}</span>
          </div>
        </v-col>
        <v-col
          cols="auto"
          class="secondary--text title"
        >
          <router-link
            v-if="linkToConnections"
            class="secondary--text"
            to="/connections"
            @click.native="handleConnectionsLinkClick"
          >
            {{ connectionsNumber }}
          </router-link>
          <span v-else>{{ connectionsNumber }}</span>
        </v-col>
      </v-row>
      <v-divider />
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { mapGetters } from 'vuex'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IUser } from '@/types/models/user.model'
import { trackMyconnectionsTap } from '@/segmentAnalytics/profile'

@Component({
  computed: {
    ...mapGetters(['profile'])
  }
})
export default class MyConnections extends Vue {
  @Prop() user: IUser
  @Prop() linkToConnections: boolean

  profile: IUser

  get title (): string {
    return this.user ? 'Connections' : 'My connections'
  }

  get connectionsNumber (): number {
    if (this.user) return this.user?.connectionsNumber || 0
    return this.profile?.connectionsNumber || 0
  }

  handleConnectionsLinkClick () {
    trackMyconnectionsTap()
  }
}
</script>
